export const i18n = {
  namespaced: true,
  state: {
    language: "es",
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
    },
  },
  actions: {
    changeLanguage({ commit }, language) {
      commit("setLanguage", language);
    },
  },
  getters: {
    currentLanguage: (state) => state.language,
  },
};
